"use client";

import { ContentfulImageConfig } from "@2u-landing-pages/types";
import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import React from "react";
import { CardProps, CustomCSSProperties } from "./Card.type";
import { LargeCard, MediumCard, SmallCard } from "./variations";

export const Card: React.FC<CardProps> = (props) => {
  const inspector = useContentfulInspectorMode();
  const style: CustomCSSProperties = {};

  // Check if imageConfig has been set. If so, aspect ratio will be ignored.
  const imageConfig = props?.entry?.fields?.image_config as unknown as ContentfulImageConfig;
  const { w: wDefault, h: hDefault } = imageConfig?.default || {};
  const { w: wMobile, h: hMobile } = imageConfig?.mobile || {};
  const resizeImage = [wDefault, hDefault, wMobile, hMobile].some((value) => value);

  if (props?.entry?.fields?.background_color)
    style["--background-color"] = `var(${props.entry.fields.background_color})`;
  if (props?.entry?.fields?.initials_background_color)
    style["--initials-background-color"] = `var(${props.entry.fields.initials_background_color})`;
  if (props?.entry?.fields?.initials_text_color)
    style["--initials-color"] = `var(${props.entry.fields.initials_text_color})`;
  if (props?.entry?.fields?.image_aspect_ratio && !resizeImage)
    style["--aspect-ratio"] = `${props.entry.fields.image_aspect_ratio}`;
  if (props?.entry?.fields?.heading_color) style["--heading-color"] = `var(${props.entry.fields.heading_color})`;
  if (props?.entry?.fields?.subhead_color) style["--subhead-color"] = `var(${props.entry.fields.subhead_color})`;
  if (props?.entry?.fields?.body_color) style["--body-color"] = `var(${props.entry.fields.body_color})`;
  if (props?.entry?.fields?.icon_color) style["--icon-color"] = `var(${props.entry.fields.icon_color})`;

  switch (props.entry.fields.variation) {
    case "small":
      return <SmallCard {...props} style={style} inspector={inspector} />;
    case "medium":
      return <MediumCard {...props} style={style} inspector={inspector} />;
    case "large":
      return <LargeCard {...props} style={style} inspector={inspector} />;
    default:
      return null;
  }
};
